import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import style from '../DemolitionServices/DemolitionServices.module.scss';
import { CivilWallTilesLayingDetails, DummyCivilWorkDetails, customCivilMarbleFlooring } from "./CivilWorkConstant";
import CivilWorkOptions from "./CivilWorkOptions";
import { saveUpdatedPageDetails, saveMetaDataUpdate } from "../../../actions/wizard";

const CivilWallTileLaying = (props:any) => {
  const dispatch = useDispatch();
  const { isDrawingsExporting } = props;
  const pageDetails = useSelector((state: any) => state.wizard.pageDetails);
  const requiredMetaDataUpdate = useSelector((state: any) => state.wizard.requiredMetaDataUpdate);

  const latestStateRef = useRef(requiredMetaDataUpdate);

  const [updatedValues, setUpdatedValues] = useState(pageDetails);

  useEffect(() => {
    setUpdatedValues(pageDetails)
  }, [pageDetails]);

  // Update the meta details while unmounting.
  useEffect(() => {
    return () => {
      updateDetailsInMeta(false);
    }
  }, [])

  // Updating Item details in meta data
  const updateItems = (details: any) => {
    const updatedObj: any = {
      ...updatedValues,
      metaData: {
        ...updatedValues?.metaData,
        [details.id]: details.value
      }
    };
    setUpdatedValues(updatedObj)
    dispatch(saveMetaDataUpdate(updatedObj))
  }

  // Save function to save details in API
  const updateDetailsInMeta = (required: boolean) => {  
    if (latestStateRef.current) {
      dispatch(saveUpdatedPageDetails(latestStateRef.current, required));
      dispatch(saveMetaDataUpdate(false))
    }
  }

  // Created a debounce to update the exiting quote details 
  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      updateDetailsInMeta(true);
    }, 4000); // Adjust the delay (in milliseconds) as needed

    latestStateRef.current = requiredMetaDataUpdate;

    return () => {
      clearTimeout(debounceTimer);
    };
  }, [requiredMetaDataUpdate]);

  return (
    <section className={style.demolition_room_container}>
      <h2 className="section_heading">Wall Tile Services - Room Level </h2>
      <div className={style.demolition_details_tabs}>
        <div className={style.civil_work_image_columns}>
          <section>
            <div>
              <h4>Elevation A</h4>
              <p>with overall wall dimensions, Starting point for Wall Tile laying with proper tile laying pattern as per tile size</p>
            </div>
          </section>
          <section>
            <div>
              <h4>Elevation B</h4>
              <p>with overall wall dimensions, Starting point for Wall Tile laying with proper tile laying pattern as per tile size</p>
            </div>
          </section>
          <section>
            <div>
              <h4>Elevation C</h4>
              <p>with overall wall dimensions, Starting point for Wall Tile laying with proper tile laying pattern as per tile size</p>
            </div>
          </section>
          <section>
            <div>
              <h4>Elevation D</h4>
              <p>with overall wall dimensions, Starting point for Wall Tile laying with proper tile laying pattern as per tile size</p>
            </div>
          </section>
        </div>
        <div className={style.civil_work_details_tabs}>
          <div className={style.demolition_item_container}>
            <h2 className="sub_tab_heading">TILE FLOORING DETAILS</h2>
            <div className={style.demolition_item_details}>
              <div className={style.demolition_items_heading}>
                <h4>Details</h4>
                <h4>Size</h4>
                <h4>UOM</h4>
              </div>
              <div className={style.demolition_items_list}>
                {
                  customCivilMarbleFlooring?.map((e, i) => (
                    <p><CivilWorkOptions details={e} isDrawingsExporting={isDrawingsExporting} updateDetails={(e) => updateItems(e)} itemDetails={updatedValues?.metaData} type={e?.type} /></p>
                  ))
                }
              </div>
              <p className={style.note_tag}>Note: Standard text for floor tile spacers should be mentioned at the bottom</p>
            </div>
          </div>
          <div className={style.demolition_sow}>
            <h2 className="sub_tab_heading">SCOPE OF WORK</h2>
            <div className={style.sow_options_list}>
              {
                CivilWallTilesLayingDetails?.map((e, i) => (
                  <div key={i} className={style.options_tab_vew}>
                    <p>{e?.label}</p>
                    <CivilWorkOptions details={e} optionsList={e?.options} isDrawingsExporting={isDrawingsExporting} updateDetails={(e) => updateItems(e)} itemDetails={updatedValues?.metaData} />
                  </div>
                ))
              }
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CivilWallTileLaying;